// extracted by mini-css-extract-plugin
module.exports = {"cart":"CartIcon_cart__hvTqJ","count":"CartIcon_count__1lR5W"};